
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms-conditions-of-use",
      function () {
        return require("private-next-pages/terms-conditions-of-use.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms-conditions-of-use"])
      });
    }
  